<template>
  <div class="custom-control custom-switch">
    <input v-model="quantityFilter" type="checkbox" class="custom-control-input" id="quantity-filter">
    <label class="custom-control-label" for="quantity-filter" v-t="`filter.quantity.title`"></label>
    <br>
  </div>
</template>

<script>
export default {
  name: "FilterQuantity1",
  data() {
    return {
      quantityFilter: false
    }
  },
  watch: {
    quantityFilter: function () {
      this.$emit('quantityFilter', this.quantityFilter)
    },
  }

}
</script>

<style scoped>

</style>